/**
 * API 設定
 * 如果前端與後端部署在同一個網域（打包後由 Flask 提供），
 * 建議設定為相對路徑。如果有指定 REACT_APP_API_BASE_URL（例如本機開發），則優先使用。
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "";

export const UPLOAD_API_URL =
  process.env.REACT_APP_UPLOAD_API_URL ||
  "https://lineimage.azurewebsites.net/api/images";
